/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateStockupRequestStockup } from './UpdateStockupRequestStockup';
import {
    UpdateStockupRequestStockupFromJSON,
    UpdateStockupRequestStockupFromJSONTyped,
    UpdateStockupRequestStockupToJSON,
} from './UpdateStockupRequestStockup';

/**
 * 
 * @export
 * @interface UpdateStockupRequest
 */
export interface UpdateStockupRequest {
    /**
     * 
     * @type {UpdateStockupRequestStockup}
     * @memberof UpdateStockupRequest
     */
    stockup?: UpdateStockupRequestStockup;
}

/**
 * Check if a given object implements the UpdateStockupRequest interface.
 */
export function instanceOfUpdateStockupRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateStockupRequestFromJSON(json: any): UpdateStockupRequest {
    return UpdateStockupRequestFromJSONTyped(json, false);
}

export function UpdateStockupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStockupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockup': !exists(json, 'stockup') ? undefined : UpdateStockupRequestStockupFromJSON(json['stockup']),
    };
}

export function UpdateStockupRequestToJSON(value?: UpdateStockupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockup': UpdateStockupRequestStockupToJSON(value.stockup),
    };
}

